export default __webpack_public_path__ + "static/015-0ba8f97c6b5a8f4a96f1ce8f0ba91a90.jpg";